import { useMutation } from "react-query";
import { authorizeLumiOnSquareup } from "../../../services/marketplace";

export const useAuthorizeLumiOnSquareup = () => {
  return useMutation(() => authorizeLumiOnSquareup());
};
